import React from 'react'
import { Trans } from 'react-i18next'

import {
  OnboardingContactType,
  OnboardingContentType,
} from '../common/models/OnboardingTemplates'
import { ICompanyMember } from '../common/models/Company'
import {
  IOnboardingInstancePopulated,
  OnboardingInstanceActivityStatus,
} from '../common/models/OnboardingInstance'

export const getActiveInstanceProperties = (
  chapters: IOnboardingInstancePopulated['chapters']
) => {
  const openChapters = chapters?.filter((chap) => !chap.isLocked)
  const openChapter = openChapters
    ? openChapters.find((chap) =>
        chap.activities.some(
          (act) => act.status === OnboardingInstanceActivityStatus.NOT_STARTED
        )
      ) || openChapters[openChapters.length - 1]
    : undefined
  const nextChapter = chapters?.find((chap) => chap.isLocked)
  const firstOpenActivity = openChapter?.activities.find(
    (act) => act.status === OnboardingInstanceActivityStatus.NOT_STARTED
  )
  const finishedActivities = openChapter?.activities.filter(
    (act) => act.status !== OnboardingInstanceActivityStatus.NOT_STARTED
  )
  const finishedChapter =
    openChapter?.activities.length === finishedActivities?.length
  const finishedStoryLine =
    finishedChapter &&
    chapters?.findIndex((chap) => chap._id === openChapter?._id) ===
      (chapters?.length || 0) - 1

  return {
    openChapter,
    nextChapter,
    firstOpenActivity,
    finishedActivities,
    finishedChapter,
    finishedStoryLine,
  }
}

export const getContactType = (
  contactType: OnboardingContactType,
  member?: ICompanyMember
) => {
  if (contactType === OnboardingContactType.SPECIFIC_MEMBER || member) {
    return {
      title: member ? (
        `${member.name}`
      ) : (
        <Trans i18nKey="general.users.user " />
      ),
      icon: 'User',
      text: (
        <Trans
          i18nKey="onboardingHelper.specificMember"
          values={{
            name: member ? (
              member.firstName
            ) : (
              <Trans i18nKey="general.users.user" />
            ),
          }}
        />
      ),
    }
  } else if (contactType === OnboardingContactType.THEIR_BUDDY) {
    return {
      title: <Trans i18nKey="onboardingHelper.titleBuddy" />,
      icon: 'Buddy',
      text: <Trans i18nKey="onboardingHelper.textBuddy" />,
    }
  } else if (contactType === OnboardingContactType.THEIR_LEAD) {
    return {
      title: <Trans i18nKey="onboardingHelper.titleLead" />,
      icon: 'Lead',
      text: <Trans i18nKey="onboardingHelper.textLead" />,
    }
  } else if (contactType === OnboardingContactType.THEIR_GUIDE) {
    return {
      title: <Trans i18nKey="onboardingHelper.titleGuide" />,
      icon: 'Buddy',
      text: <Trans i18nKey="onboardingHelper.textGuide" />,
    }
  } else if (contactType === OnboardingContactType.DECIDE_LATER) {
    return {
      title: <Trans i18nKey="onboardingHelper.titleDecideLater" />,
      icon: 'ChevronRight',
      text: <Trans i18nKey="onboardingHelper.textDecideLater" />,
    }
  } else if (contactType === OnboardingContactType.ALL_TEAM_MEMBERS) {
    return {
      title: <Trans i18nKey="onboardingHelper.titleAllTeam" />,
      icon: 'Duplicate',
      text: <Trans i18nKey="onboardingHelper.textAllTeam" />,
    }
  } else {
    return {
      title: <Trans i18nKey="general.onboarding.noContact" />,
      icon: 'NoUser',
    }
  }
}
export const getContentType = (contentType: OnboardingContentType) => {
  switch (contentType) {
    case OnboardingContentType.SUBTITLE:
    default:
      return {
        title: <Trans i18nKey="onboardingHelper.titleSubtitle" />,
        subtitle: <Trans i18nKey="onboardingHelper.subtitleSubtitle" />,
        icon: 'Heading',
      }
    case OnboardingContentType.TEXT_FIELD:
      return {
        title: <Trans i18nKey="onboardingHelper.titleTextField" />,
        subtitle: <Trans i18nKey="onboardingHelper.subtitleTextField" />,
        icon: 'TextField',
      }
    case OnboardingContentType.LINK_BUTTON:
      return {
        title: <Trans i18nKey="onboardingHelper.titleLinkButton" />,
        subtitle: <Trans i18nKey="onboardingHelper.subtitleLinkButton" />,
        icon: 'Link',
      }
  }
}
